export default {"src":"/_next/static/media/tour-guide-icon.84a8b305.svg","height":24,"width":30,"blurWidth":0,"blurHeight":0};